module.exports = __webpack_public_path__ + "img/iphone-back.290a8d89.svg";